import type { FC } from 'react';

import { useUsercentricsStyleInjection } from './use-usercentrics-style-injection';

const STYLE_ID = 'xing-uc-dark-theme';

export const DarkColorscheme: FC = () => {
  const bgColor = '#161C24';
  const primaryColor = '#C6F16D';
  const acceptBtnFontColor = '#1D2124';
  const acceptBtnHoverBgColor = '#A7E770';
  const secondaryBtnColor = '#616D7D';
  const secondaryBtnFontColor = '#FFFFFF';
  const secondaryBtnHoverBgColor = '#A7E770';
  const fontfamily = 'Xing Sans, helvetica, arial, sans-serif';
  const fontcolor = '#FFFFFF';
  const anchorlinkColor = '#0698A0';
  const accentColor = '#8A9DA6';

  const customStyle = `
    :host(#usercentrics-cmp-ui) #main-view,
    :host(#usercentrics-cmp-ui) #uc-cmp-header {
      background-color: ${bgColor} !important;
    }

    /* V3 Main Dialog */
    :host(#usercentrics-cmp-ui) #uc-main-dialog {
      background-color: ${bgColor} !important;
      color: ${fontcolor} !important;
      font-family: ${fontfamily};
    }

    /* V3 Button styles */
    :host(#usercentrics-cmp-ui) #accept {
      background-color: ${primaryColor} !important;
      color: ${acceptBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    :host(#usercentrics-cmp-ui) #accept:hover {
      background-color: ${acceptBtnHoverBgColor} !important;
    }

    :host(#usercentrics-cmp-ui) #deny {
      background-color: ${secondaryBtnColor} !important;
      color: ${secondaryBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    :host(#usercentrics-cmp-ui) #deny:hover {
      background-color: ${secondaryBtnHoverBgColor} !important;
    }

    :host(#usercentrics-cmp-ui) #more {
      background-color: ${secondaryBtnColor} !important;
      color: ${secondaryBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    :host(#usercentrics-cmp-ui) #more:hover {
      background-color: ${secondaryBtnHoverBgColor} !important;
    }

    :host(#usercentrics-cmp-ui) #save {
      background-color: ${secondaryBtnColor} !important;
      color: ${secondaryBtnFontColor} !important;
      font-family: ${fontfamily};
      font-weight: bold;
      border: none !important;
    }
    :host(#usercentrics-cmp-ui) #save:hover {
      background-color: ${secondaryBtnHoverBgColor} !important;
    }

    /* V3 Text and backgrounds */
    :host(#usercentrics-cmp-ui) h1,
    :host(#usercentrics-cmp-ui) h2,
    :host(#usercentrics-cmp-ui) h3,
    :host(#usercentrics-cmp-ui) p,
    :host(#usercentrics-cmp-ui) span,
    :host(#usercentrics-cmp-ui) div {
      color: ${fontcolor} !important;
    }

    :host(#usercentrics-cmp-ui) a {
      color: ${anchorlinkColor} !important;
      text-decoration: underline;
    }

    /* V3 Tabs */
    :host(#usercentrics-cmp-ui) #uc-tabs-header {
      background-color: ${bgColor} !important;
    }
    :host(#usercentrics-cmp-ui) #uc-tabs-header button {
      color: ${fontcolor} !important;
      font-family: ${fontfamily};
    }
    :host(#usercentrics-cmp-ui) #uc-tabs-header button[aria-selected="true"] {
      border-bottom-color: ${fontcolor} !important;
    }

    /* V3 Content areas */
    :host(#usercentrics-cmp-ui) [class*="content"],
    :host(#usercentrics-cmp-ui) [class*="container"],
    :host(#usercentrics-cmp-ui) [class*="panel"],
    :host(#usercentrics-cmp-ui) [class*="list"],
    :host(#usercentrics-cmp-ui) [class*="card"],
    :host(#usercentrics-cmp-ui) [class*="header"],
    :host(#usercentrics-cmp-ui) [class*="footer"] {
      background-color: transparent !important;
      color: ${fontcolor} !important;
    }

    /* V3 Borders */
    :host(#usercentrics-cmp-ui) [class*="border"],
    :host(#usercentrics-cmp-ui) [class*="divider"] {
      border-color: ${accentColor} !important;
    }

    /* Remove UC Branding via CSS */
    :host(#usercentrics-cmp-ui) a[href*="usercentrics.com"] {
      display: none !important;
    }
  `;

  useUsercentricsStyleInjection({ customStyle, styleId: STYLE_ID });

  return null;
};
